import React from 'react';
import { Dialog, DialogContent, Button, Grid, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import GuardianImageSuccess from '../../../../assets/icon/Add_guardian_success.svg';
import './MinPromise.css';

const MinPromisePopup4 = ({ handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DialogContent>
      <Grid container direction="column" alignItems="center">
        {/* Image */}
        <Grid item>
          <img
            src={GuardianImageSuccess}
            alt="Add Guardian"
            style={{
              width: isMobile ? '120px' : '200px',
              height: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>

        {/* Title */}
        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="h3"
            align="left" // Align text to the left
            fontSize={isMobile ? '24px' : '30px'}
            fontWeight="800"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Congratulations!
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            We ask that you complete a 0.00 payment verification through Apple
            or Google Pay to ensure security and verify your identity, giving
            your child a blue tick so we know who you are.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Once this is completed, we’ll notify your camp that you’ve activated
            your account and made the 20-Minute Promise.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body1"
            align="left" // Align text to the left
            fontSize={isMobile ? '14px' : '18px'}
            fontWeight="700"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Thank you for joining this learning revolution and for choosing to
            help your child thrive in a world that celebrates creativity and
            imagination!
          </Typography>
        </Grid>
      </Grid>

      {/* Button */}
      <Grid container direction="column" alignItems="center">
        <Grid item width="100%" sx={{ maxWidth: '392px !important' }}>
          <button
            className="Yes_btn"
            style={{
              marginTop: isMobile ? '16px' : '20px',
              fontSize: isMobile ? '14px' : '16px',
              width: '100%',
            }}
            onClick={handleClose}
          >
            Continue
          </button>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default MinPromisePopup4;
